import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import CacaAoTesouroApp from '../../components/cacaAoTesouro';
import { checkInfoActiveHunt } from '../../components/cacaAoTesouro/actions/CacaAoTesouroAction';

const headerTags = {
    title: 'Caça ao Tesouro - Navegue e encontre o seu prêmio', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Navegue no site da Antena 1, encontre o baú do tesouro, clique e ganhe o seu prêmio. São ingressos de cinema, shows, viagens e muito outros brindes!',
        keywords: 'promoção, prêmios, brindes, viagem, ingressos de cinema, ingressos teatro, estadia em hotéis, estadias em pousadas, spa, cd, dvd, camisetas, blusas, canecas, livros, vouchers',
        'og:title': 'Caça ao Tesouro - Navegue e encontre o seu prêmio',
        'og:description': 'Navegue no site da Antena 1, encontre o baú do tesouro, clique e ganhe o seu prêmio. São ingressos de cinema, shows, viagens e muito outros brindes!',
        'og:image': 'https://a1media.antena1.com.br/image/share/caca-ao-tesouro.png',
    },
};

class CacaAoTesouro extends Component {
    static fetchData(store) {
        return store.dispatch(checkInfoActiveHunt());
    }

    render() {
        return (
            <div className="pageWrapper">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <CacaAoTesouroApp />
            </div>
        );
    }
}

export default CacaAoTesouro;
